import {IHolidayCalendar, THolidayCalendarSave} from '../../api/shared/app-domain/holidays';
import {TDifferenceKeys} from '../../shared/types';
import {IWorkweek, TWorkweekSave} from '../../api/shared/app-domain/dictionaries';

export const HOLIDAY_CALENDAR_EXCLUDED_PROPS: Array<TDifferenceKeys<THolidayCalendarSave, IHolidayCalendar>>
  = ['id', 'holidayCount', 'createdAt', 'updatedAt', 'baseName', 'countryName', 'countryFlag'];

export const WORKWEEK_EXCLUDED_PROPS: Array<TDifferenceKeys<TWorkweekSave, IWorkweek>>
  = ['id', 'createdAt', 'updatedAt', 'total'];
